const Highcharts = require('highcharts');
const Exporting = require('highcharts/modules/exporting');

let chart, chart_title, chart_subtitle;
const chartOptions = {
  chart: {
    type: 'area',
    height: 257
  },
  title: {
    text: undefined
  },
  lang: {
    noData: 'No data available'
  },
  xAxis: {
    type: 'datetime',
    gridLineColor: '#DCE6E8',
    gridLineWidth: 1,
    lineColor: 'transparent',
    tickWidth: 0,
    labels: {
      style: {
        color: 'rgba(114, 114, 114, 0.5)',
      }
    },
  },
  yAxis: {
    gridLineColor: '#DCE6E8',
    gridLineWidth: 1,
    opposite: true,
    title: {
      text: undefined
    },
    labels: {
      style: {
        color: 'rgba(114, 114, 114, 0.5)',
        fontSize: '14px',
      }
    },
  },
  tooltip: {
    backgroundColor: '#FFFFFF',
    borderColor: '#9FB5CB',
    borderRadius: 2,
    borderWidth: 1,
    padding: 5,
    // shared: true,
    useHTML: true,
    headerFormat: '<table class="statistic-table" style="width:150px"><tr><th style="text-align: center">{series.name}: {point.y}</th></tr>',
    pointFormat: '',
    footerFormat: '<tr><td style="text-align: center">{point.key}</td></tr></table>',
    style: {
      fontSize: '14px',
    },
  },
  plotOptions: {
    series: {
      lineWidth: 4,
      name: 'Views',
      color: '#2B4764',
      pointPlacement: 'on'
    },
    line: {
      marker: {
        enabled: false
      }
    },
    area: {
      borderWidth: 5,
      fillColor: 'rgba(155, 204, 255, 0.5)',
      threshold: null,

      marker: {
        enabled: false,
        symbol: 'circle',

        states: {
          hover: {
            lineColor: '#2B4764',
            fillColor: '#ffffff',
            lineWidth: 3,
            radius: 8,
            enabled: true
          }
        }
      },
    }
  },
  credits: {
    enabled: false
  },
  // legend: {
  //   enabled: false
  // },
  exporting: {
    enabled: false
  }
}

Highcharts.setOptions(chartOptions)

function makeRequest(form) {
  $.ajax({
    url: form.attr('action'),
    method: 'POST',
    elem: form,
    data: new FormData(form[0]),
    success: function (response) {
      if (response.data.length) {
        chart = Highcharts.chart(form.find('.stat-container')[0], {
          series: response.data.map(({ name, data }) => ({
            name, data: data.map(el => [new Date(el.date).getTime(), parseFloat(el.count)])
          })),
          xAxis: {
            pointInterval: response.interval
          }
        });
        const analyticsViews = response.data
          .reduce((acc, cur) => {
            acc[cur.order_id || cur.name] = cur.data.reduce((acc, { count }) => acc + Number(count), 0)
            return acc;
          }, {});

        const views = Object.values(analyticsViews).reduce((acc, cur) => acc + cur, 0);
        form.find('.stat-container').removeClass('empty');
        form.find('.menu-parameters').show();
        form.find('.chart_count').show();
        form.find('.chart_count').text(`${views} All`);

        chart_title = response.title;
        chart_subtitle = response.subtitle;

        if (response.tooltip_title) {
          form.find('.analytics_tooltip .tooltip-content').text(response.tooltip_title);
        }
      } else {
        form.find('.menu-parameters').hide();
        form.find('.chart_count').hide();
        form.find('.stat-container').addClass('empty').empty().append(`
          <div class="">
            <span class="m-4 text-center d-block">You don\'t have data for this chart. To get promoted profile go to marketing center and use the commercial services or change analytics result settings.</span>
              <a href="/payments/membership" class="d-block w-100 mt-5 p-3 text-uppercase lh-sm text-matterhorn border border-matterhorn bg-transparent interaction-trnsp-mthrn text-center cursor-pointer">MARKETING CENTER</a>
          </div>
        `)
      }
    },
  })
}

global.modules.set({
  async init(context) {
    Exporting(Highcharts);
    $('.analytics_accordion', context).accordion(function (elem) {
      $(elem).one('click', function () {
        setTimeout(function () {
          const form = elem.next();
          $('[name="period"]').on('click', function () {
            $('[name="period"]').removeClass('active');
            $(this).addClass('active');
          })
          form.on('change', function (e) {
            if ($(e.target).hasClass('select2-search__field')) {
              return;
            }
            $(this).trigger('submit');
          })
          form.on('submit', function (e) {
            e.preventDefault();
            makeRequest(form);
          })
          makeRequest(form);
        }, 400)
      })
      $(elem).on('click', function () {
        $(this).toggleClass('opened')
      })
    });

    $('.export_chart').on('click', function () {
      const export_type = {
        pdf: 'application/pdf',
        png: 'image/png'
      }
      chart.update({
        title: { text: chart_title || '' },
        subtitle: { text: chart_subtitle || '' }
      });
      chart.exportChart({
        type: export_type[$(this).data('type')],
      });
      chart.update({
        title: { text: undefined },
        subtitle: { text: undefined }
      });
    });
  }
})